import { os, eventNames, methodNames } from './core/utils';
import { setupWebViewJavascriptBridge, SuperAppBridgeClass } from './core/index';
let xgimiJssdk = {
    name: 'xgimi-jssdk',
    isXgimi: os.isSuperApp,
    status: 0,
    bridge: null,
    info: {
        EventName: eventNames,
        MethodName: methodNames
    },
    addListener: () => { },
    removeListener: () => { },
    config: (opt) => new Promise((resolve, reject) => { }),
    ready: (isForce) => new Promise((resolve, reject) => { }),
    onSubEvents: (name, data) => { }
};
xgimiJssdk.addListener = (eventName, callback) => {
    xgimiJssdk.ready().then((appBridge) => {
        appBridge.addBridgeListener(eventName, callback);
    });
};
xgimiJssdk.removeListener = (eventName, callback) => {
    xgimiJssdk.ready().then((appBridge) => {
        appBridge.removeBridgeListener(eventName, callback);
    });
};
const bridgeMethodsBindToXgimi = (methods, isForce) => {
    for (let i = 0; i < methods.length; i++) {
        const methodName = methods[i];
        if (methodName) {
            xgimiJssdk[methodName] = (_data) => {
                let _isForce = false;
                //有方法更新 只设置一次
                if (isForce && i == 0) {
                    _isForce = true;
                }
                return xgimiJssdk.ready(_isForce).then((appBridge) => {
                    return appBridge && appBridge.callHandler(methodName, _data, true);
                });
            };
        }
    }
};
bridgeMethodsBindToXgimi(xgimiJssdk.info.MethodName);
let cbQueue = [];
/**
 * 准备完成
 * */
xgimiJssdk.ready = (isForce) => {
    return new Promise((resolve, reject) => {
        // 不在xgimi app 直接返回
        if (!os.isSuperApp) {
            return reject('当前不在xgimi app！');
        }
        // 添加到队列
        cbQueue.push(resolve);
        // 注册中等待
        if (xgimiJssdk.status == 1)
            return;
        if (xgimiJssdk.status === 2 && xgimiJssdk.bridge && !isForce) {
            cbQueue.map(_resolve => {
                _resolve(xgimiJssdk.bridge);
            });
            cbQueue = [];
            return;
        }
        xgimiJssdk.status = 1;
        setupWebViewJavascriptBridge((wvbridge) => {
            const _appBridge = new SuperAppBridgeClass(wvbridge, xgimiJssdk.info.EventName, xgimiJssdk.onSubEvents);
            xgimiJssdk.bridge = _appBridge;
            if (_appBridge && _appBridge.bridge && typeof _appBridge.bridge.init === 'function') {
                _appBridge.bridge.init();
            }
            xgimiJssdk.status = 2;
            cbQueue.map(_resolve => {
                _resolve(_appBridge);
            });
            cbQueue = [];
        });
    });
};
/**
 * 初始化配置
 * opt {Object}
 * */
xgimiJssdk.config = (opt) => {
    return new Promise((reslove, reject) => {
        let _xgimi = window.xgimiJssdk ? window.xgimiJssdk : xgimiJssdk;
        const _EventName = opt ? (opt.eventName || []) : [];
        const _MethodName = opt ? (opt.methodName || []) : [];
        _xgimi.info.EventName = Array.from(new Set([...eventNames, ..._EventName]));
        _xgimi.info.MethodName = Array.from(new Set([...methodNames, ..._MethodName]));
        bridgeMethodsBindToXgimi(_xgimi.info.MethodName, true);
    });
};
window['xgimiJssdk'] = xgimiJssdk;
window['$xgimi'] = { ...xgimiJssdk };
export { xgimiJssdk };
//# sourceMappingURL=index.js.map